import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 兑换函数
 * @param {string} token 用户的 JWT Token
 * @param {string} redeemCode 兑换码
 * @param {string} username 用户名
 * @returns {Promise<Object>} 返回后端的响应数据
 */
export const redeem = async (
  token: string,
  redeemCode: string,
  username: string
): Promise<any> => {
  try {
    const apiBaseUrl = getApiBaseUrl();

    const response = await axios.post(
      `${apiBaseUrl}/useRedeem`,
      { redeem_code: redeemCode, username },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // 返回后端响应数据
  } catch (err: any) {
    console.error('兑换失败:', err.message);
    if (err.response?.data?.error) {
      throw new Error(err.response.data.error);
    }
    throw new Error('兑换失败，请检查兑换码或网络连接');
  }
};

